import React from "react";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { AvField, AvInput } from "availity-reactstrap-validation";
import PropTypes from "prop-types";
import CustomSelect from "../../../Common/CustomSelect";
import { getDefaultValueForSelect } from "../../../../helpers/utils";
import { useSelector } from "react-redux";

const FormByKpiIndicators = ({
  kpiIndicator,
  cost,
  suffix,
  prefix,
  isLoading,
  isFormSubmit,
}) => {
  const [isCustom, setIsCustom] = React.useState(false);
  const [isKpiUnique, setIsKpiUnique] = React.useState(!!cost?.kpi_is_unique);

  const events = useSelector(state => state.Events.events);

  const trackers = [
    { label: "Adjust", value: "Adjust" },
    { label: "AppsFlyer", value: "AppsFlyer" },
  ];

  switch (kpiIndicator) {
    case "RR":
      return (
        <React.Fragment key={cost.key + "_KPI_INDICATOR_RR"}>
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label htmlFor="">RR:</Label>
                <AvField
                  name={prefix + "__kpi" + suffix}
                  placeholder="RR"
                  value={cost?.[`${prefix}__kpi`] || ""}
                  type="number"
                  className="form-control"
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      );
    case "CR":
      return (
        <React.Fragment key={cost.key + "_KPI_INDICATOR_conversion"}>
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label htmlFor="">CR:</Label>
                <AvField
                  name={prefix + "__kpi" + suffix}
                  placeholder="CR"
                  value={cost?.[prefix + "__kpi"]}
                  type="number"
                  className="form-control"
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">
                  KPI Event
                  <span
                    className="btn__add-custom-event"
                    onClick={() => setIsCustom(prev => !prev)}
                  >
                    ({!isCustom ? "Add custom event" : "View events"})
                  </span>
                  :
                </Label>
                {!isCustom ? (
                  <CustomSelect
                    name={prefix + "__kpi_events" + suffix}
                    options={events}
                    placeholder="Select event..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event field is required!"
                    defaultValue={getDefaultValueForSelect(
                      cost?.[`${prefix}__kpi_events`]
                    )}
                    isMulti
                    isLoading={isLoading}
                    isFormSubmit={isFormSubmit}
                  />
                ) : (
                  <CustomSelect
                    name={"kpi_custom_event_names" + suffix}
                    placeholder="Event name..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event name field is required!"
                    isMulti
                    creatable
                    required
                    isFormSubmit={isFormSubmit}
                  />
                )}
                {/* <AvField
                    name={"kpi_custom_event_name" + suffix}
                    placeholder="Event name..."
                    type="text"
                    errorMessage="Event name field is required!"
                    className="form-control"
                    validate={{
                      required: { value: true },
                    }}
                  /> */}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                {isCustom && (
                  <>
                    <Label htmlFor="">Tracker</Label>
                    <CustomSelect
                      name={"kpi_custom_event_tracker" + suffix}
                      options={trackers}
                      defaultValue={trackers[0]}
                      placeholder="Select tracker..."
                      classNamePrefix="select2-selection"
                      errorMessage="Tracker field is required!"
                      required
                      isLoading={isLoading}
                      isFormSubmit={isFormSubmit}
                    />
                  </>
                )}
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      );
    case "Event_cost":
      return (
        <React.Fragment key={cost.key + "_KPI_INDICATOR_event_cost"}>
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label htmlFor="">Event cost:</Label>
                <AvField
                  name={prefix + "__kpi" + suffix}
                  placeholder="Event cost..."
                  value={cost?.[`${prefix}__kpi`] || ""}
                  type="number"
                  className="form-control"
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">
                  KPI Event
                  <span
                    className="btn__add-custom-event"
                    onClick={() => setIsCustom(prev => !prev)}
                  >
                    ({!isCustom ? "Add custom event" : "View events"})
                  </span>
                  :
                </Label>
                {!isCustom ? (
                  <CustomSelect
                    name={prefix + "__kpi_events" + suffix}
                    options={events}
                    placeholder="Select event..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event field is required!"
                    defaultValue={getDefaultValueForSelect(
                      cost?.[`${prefix}__kpi_events`]
                    )}
                    isMulti
                    isLoading={isLoading}
                    isFormSubmit={isFormSubmit}
                  />
                ) : (
                  <AvField
                    name={"kpi_" + suffix}
                    placeholder="Event name..."
                    type="text"
                    errorMessage="Event name field is required!"
                    className="form-control"
                    validate={{
                      required: { value: true },
                    }}
                  />
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                {isCustom && (
                  <>
                    <Label htmlFor="">Tracker</Label>
                    <CustomSelect
                      name={"kpi_custom_event_tracker" + suffix}
                      options={trackers}
                      defaultValue={trackers[0]}
                      placeholder="Select tracker..."
                      classNamePrefix="select2-selection"
                      errorMessage="Tracker field is required!"
                      required
                      isLoading={isLoading}
                      isFormSubmit={isFormSubmit}
                    />
                  </>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <AvInput
                  className={"mr-1"}
                  style={{ marginBottom: "10.5px" }}
                  type="checkbox"
                  name={"kpi_is_unique" + suffix}
                  value={!!cost?.[`${prefix}__kpi_is_unique`] || false}
                />
                <Label check for={"kpi_is_unique" + suffix}>
                  Is unique
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      );
    case "ROAS":
      return (
        <>
          <Row key={"_KPI_INDICATOR_roas" + cost.key}>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label htmlFor="">ROAS:</Label>
                <AvField
                  name={prefix + "__kpi" + suffix}
                  placeholder="ROAS..."
                  value={cost?.[`${prefix}__kpi`] || ""}
                  type="number"
                  className="form-control"
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row key={"_KPI_INDICATOR_event_percent" + cost.key}>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">
                  KPI Event
                  <span
                    className="btn__add-custom-event"
                    onClick={() => setIsCustom(prev => !prev)}
                  >
                    ({!isCustom ? "Add custom event" : "View events"})
                  </span>
                  :
                </Label>
                {!isCustom ? (
                  <CustomSelect
                    name={prefix + "__kpi_events" + suffix}
                    options={events}
                    placeholder="Select event..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event field is required!"
                    defaultValue={getDefaultValueForSelect(
                      cost?.[`${prefix}__kpi_events`]
                    )}
                    isMulti
                    isLoading={isLoading}
                    isFormSubmit={isFormSubmit}
                  />
                ) : (
                  <CustomSelect
                    name={"kpi_custom_event_names" + suffix}
                    placeholder="Event name..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event name field is required!"
                    isMulti
                    creatable
                    required
                    isFormSubmit={isFormSubmit}
                  />
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                {isCustom && (
                  <>
                    <Label htmlFor="">Tracker</Label>
                    <CustomSelect
                      name={"kpi_custom_event_tracker" + suffix}
                      options={trackers}
                      placeholder="Select tracker..."
                      defaultValue={trackers[0]}
                      classNamePrefix="select2-selection"
                      errorMessage="Tracker field is required!"
                      required
                      isLoading={isLoading}
                      isFormSubmit={isFormSubmit}
                    />
                  </>
                )}
              </FormGroup>
            </Col>
          </Row>
        </>
      );
    case "CPI":
      return (
        <Row key={"_KPI_INDICATOR_cpi" + cost.key}>
          <Col md="6">
            <FormGroup className="mb-3">
              <Label htmlFor="">CPI:</Label>
              <AvField
                name={prefix + "__kpi" + suffix}
                placeholder="CPI..."
                value={cost?.[`${prefix}__kpi`] || ""}
                type="number"
                className="form-control"
                validate={{
                  required: { value: true },
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      );
    case "Event_%":
      return (
        <React.Fragment key={"_KPI_INDICATOR_Event_%" + cost.key}>
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label htmlFor="">Event %:</Label>
                <AvField
                  name={prefix + "__kpi" + suffix}
                  placeholder="Event %..."
                  value={cost?.[`${prefix}__kpi`] || ""}
                  type="number"
                  className="form-control"
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row key={"_KPI_INDICATOR_event_percent" + cost.key}>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">
                  KPI Event
                  <span
                    className="btn__add-custom-event"
                    onClick={() => setIsCustom(prev => !prev)}
                  >
                    ({!isCustom ? "Add custom event" : "View events"})
                  </span>
                  :
                </Label>
                {!isCustom ? (
                  <CustomSelect
                    name={prefix + "__kpi_events" + suffix}
                    options={events}
                    placeholder="Select event..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event field is required!"
                    defaultValue={getDefaultValueForSelect(
                      cost?.[`${prefix}__kpi_events`]
                    )}
                    isLoading={isLoading}
                    isFormSubmit={isFormSubmit}
                    isMulti
                  />
                ) : (
                  <CustomSelect
                    name={"kpi_custom_event_names" + suffix}
                    placeholder="Event name..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event name field is required!"
                    isMulti
                    creatable
                    required
                    isFormSubmit={isFormSubmit}
                  />
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                {isCustom && (
                  <>
                    <Label htmlFor="">Tracker</Label>
                    <CustomSelect
                      name={"kpi_custom_event_tracker" + suffix}
                      options={trackers}
                      defaultValue={trackers[0]}
                      placeholder="Select tracker..."
                      classNamePrefix="select2-selection"
                      errorMessage="Tracker field is required!"
                      required
                      isLoading={isLoading}
                      isFormSubmit={isFormSubmit}
                    />
                  </>
                )}
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      );
    case "Revenue":
      return (
        <React.Fragment key={"_KPI_INDICATOR_revenue" + cost.key}>
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label htmlFor="">Revenue:</Label>
                <AvField
                  name={prefix + "__kpi" + suffix}
                  placeholder="Revenue..."
                  value={cost?.[`${prefix}__kpi`] || ""}
                  type="number"
                  className="form-control"
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">
                  KPI Event
                  <span
                    className="btn__add-custom-event"
                    onClick={() => setIsCustom(prev => !prev)}
                  >
                    ({!isCustom ? "Add custom event" : "View events"})
                  </span>
                  :
                </Label>
                {!isCustom ? (
                  <CustomSelect
                    name={prefix + "__kpi_events" + suffix}
                    options={events}
                    placeholder="Select event..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event field is required!"
                    defaultValue={getDefaultValueForSelect(
                      cost?.[`${prefix}__kpi_events`]
                    )}
                    isMulti
                    isLoading={isLoading}
                    isFormSubmit={isFormSubmit}
                  />
                ) : (
                  <CustomSelect
                    name={"kpi_custom_event_names" + suffix}
                    placeholder="Event name..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event name field is required!"
                    isMulti
                    creatable
                    required
                    isFormSubmit={isFormSubmit}
                  />
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                {isCustom && (
                  <>
                    <Label htmlFor="">Tracker</Label>
                    <CustomSelect
                      name={
                        prefix === "cpi"
                          ? "custom_event_tracker" + suffix
                          : "kpi_custom_event_tracker" + suffix
                      }
                      options={trackers}
                      defaultValue={trackers[0]}
                      placeholder="Select tracker..."
                      classNamePrefix="select2-selection"
                      errorMessage="Tracker field is required!"
                      required
                      isLoading={isLoading}
                      isFormSubmit={isFormSubmit}
                    />
                  </>
                )}
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      );
    case "Cost_per_event":
      return (
        <React.Fragment key={"_KPI_INDICATOR_event_percent" + cost.key}>
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label htmlFor="">Cost per event:</Label>
                <AvField
                  name={prefix + "__kpi" + suffix}
                  placeholder="Cost per event..."
                  value={cost?.[`${prefix}__kpi`] || ""}
                  type="number"
                  className="form-control"
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">
                  KPI Event
                  <span
                    className="btn__add-custom-event"
                    onClick={() => setIsCustom(prev => !prev)}
                  >
                    ({!isCustom ? "Add custom event" : "View events"})
                  </span>
                  :
                </Label>
                {!isCustom ? (
                  <CustomSelect
                    name={prefix + "__kpi_events" + suffix}
                    options={events}
                    placeholder="Select event..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event field is required!"
                    defaultValue={getDefaultValueForSelect(
                      cost?.[`${prefix}__kpi_events`]
                    )}
                    isMulti
                    isLoading={isLoading}
                    isFormSubmit={isFormSubmit}
                  />
                ) : (
                  <CustomSelect
                    name={"kpi_custom_event_names" + suffix}
                    placeholder="Event name..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event name field is required!"
                    isMulti
                    creatable
                    required
                    isFormSubmit={isFormSubmit}
                  />
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                {isCustom && (
                  <>
                    <Label htmlFor="">Tracker</Label>
                    <CustomSelect
                      name={"kpi_custom_event_tracker" + suffix}
                      options={trackers}
                      defaultValue={trackers[0]}
                      placeholder="Select tracker..."
                      classNamePrefix="select2-selection"
                      errorMessage="Tracker field is required!"
                      required
                      isLoading={isLoading}
                      isFormSubmit={isFormSubmit}
                    />
                  </>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <AvInput
                  className={"mr-1"}
                  style={{ marginBottom: "10.5px" }}
                  type="checkbox"
                  name={"kpi_is_unique" + suffix}
                  value={!!cost?.[`${prefix}__kpi_is_unique`] || false}
                />
                <Label check for={"kpi_is_unique" + suffix}>
                  Is unique
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      );
    case "AOV":
      return (
        <React.Fragment key={cost.key + "_KPI_INDICATOR_AOV"}>
          <Row>
            <Col md="6">
              <Label htmlFor="">AOV:</Label>
              <FormGroup className="mb-3">
                <AvField
                  name={prefix + "__kpi" + suffix}
                  placeholder="AOV"
                  value={cost?.[`${prefix}__kpi`] || ""}
                  type="number"
                  className="form-control"
                  errorMessage="AOV field is required!"
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup className="mb-3">
                <Label htmlFor="">
                  KPI Event
                  <span
                    className="btn__add-custom-event"
                    onClick={() => setIsCustom(prev => !prev)}
                  >
                    ({!isCustom ? "Add custom event" : "View events"})
                  </span>
                  :
                </Label>
                {!isCustom ? (
                  <CustomSelect
                    name={prefix + "__kpi_events" + suffix}
                    options={events}
                    placeholder="Select event..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event field is required!"
                    defaultValue={getDefaultValueForSelect(
                      cost?.[`${prefix}__kpi_events`]
                    )}
                    isMulti
                    isLoading={isLoading}
                    isFormSubmit={isFormSubmit}
                  />
                ) : (
                  <CustomSelect
                    name={"kpi_custom_event_names" + suffix}
                    placeholder="Event name..."
                    classNamePrefix="select2-selection"
                    errorMessage="Event name field is required!"
                    isMulti
                    creatable
                    required
                    isFormSubmit={isFormSubmit}
                  />
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className="mb-3">
                {isCustom && (
                  <>
                    <Label htmlFor="">Tracker</Label>
                    <CustomSelect
                      name={"kpi_custom_event_tracker" + suffix}
                      options={trackers}
                      defaultValue={trackers[0]}
                      placeholder="Select tracker..."
                      classNamePrefix="select2-selection"
                      errorMessage="Tracker field is required!"
                      required
                      isLoading={isLoading}
                      isFormSubmit={isFormSubmit}
                    />
                  </>
                )}
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      );
    case "Retention":
      return (
        <React.Fragment key={cost.key + "_KPI_INDICATOR_retention"}>
          <Row>
            <Col md="6">
              <FormGroup className="mb-3">
                <Label htmlFor="">Retention:</Label>
                <AvField
                  name={prefix + "__kpi" + suffix}
                  placeholder="Retention"
                  value={cost?.[`${prefix}__kpi`] || ""}
                  type="number"
                  className="form-control"
                  required
                  validate={{
                    required: { value: true },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </React.Fragment>
      );
    default:
      return <React.Fragment />;
  }
};

FormByKpiIndicators.propTypes = {
  kpiIndicator: PropTypes.any,
  cost: PropTypes.any,
  suffix: PropTypes.string,
  prefix: PropTypes.string,
  isLoading: PropTypes.bool,
  isFormSubmit: PropTypes.bool,
};

export default FormByKpiIndicators;
